<script>

import { Line } from 'vue-chartjs';

export default {
  extends: Line,

  name: 'LineChart',

  components: {
  },

  props: {
    chartData: { type: Object },
    chartOptions: { type: Object }
  },

  data() {
    return {
      toolTipDelay: { delay: { "show": 500, "hide": 100 } },
      currentWidth: undefined,
      data: {
					labels: ['Wave1', 'Wave2', 'Wave3', 'Wave4', 'Wave5', 'Wave6', 'Wave7'],
					datasets: [{
						label: 'SurveyWaves',
						backgroundColor: 'rgba(51, 51, 51, 0.7)',
            borderColor: 'rgba(51, 51, 51, 0.7)',
            pointBackgroundColor: ['#ff1500', '#ffd800', '#4cff00', '#ff1500', '#ffd800', '#4cff00', '#ff1500'],
            pointBorderColor: ['#ff1500', '#ffd800', '#4cff00', '#ff1500', '#ffd800', '#4cff00', '#ff1500'],
            pointRadius: 4,
            pointHoverRadius: 5,
						data: [32.12, 77.77, 0, 99.99, 33.33, 63.32, 23.99],
						fill: false,
					}]
				},
      options: {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100,
                    stepSize: 25
                }
            }],
            xAxes: [{ ticks: { display: false } }]
        },
        legend: { display: false },
        elements: {
          line: { tension: 0 }
        },
        animation: { duration: 0 },
        hover: { animationDuration: 0 },
        responsive: true,
        responsiveAnimationDuration: 0,
        maintainAspectRatio: false,
        layout: {
          padding: {
            right: 5
          }
        },
      }
    };
  },
  
  mounted() {
    // console.log('ChartCell - mounted');
    if (this.chartData) {
      this.data = this.chartData;
    }
    if (this.chartOptions) {
      this.options = this.chartOptions;
    }
    this.renderChart(this.data, this.options);
  },

  methods: {

  },

  computed: {

  }
};
</script>
<style>

</style>
